import { enUS } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

export const formatDate = (
	date: string,
	format: string = 'EEE, MMM d h:mm a zzz',
) => {
	return formatInTimeZone(date, 'America/New_York', format, {
		locale: enUS,
	});
};
